import {Button, Checkbox} from 'antd';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import './CheckboxItem.css';
import LabelEncoder from './LabelEncoder';
import SAInput from '../common/input/SAInput';
import SAInputDistance from '../common/input/SAInputDistance';
import SATimePicker from '../common/input/SATimePicker';
import SAInputCurrency from '../common/input/SAInputCurrency';
import ServiceCategorySelector from '../common/select/ServiceCategorySelector';
import Constants from '../../services/Constants';


class CheckboxItem extends Component {

  static propTypes = {
    canEditMLItem: PropTypes.bool,
    canWrite: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    item: PropTypes.shape({
      default: PropTypes.bool,
      active: PropTypes.bool,
      duration: PropTypes.string,
    }),
    labelKey: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemoveMLItem: PropTypes.func,
    onSaveMLItem: PropTypes.func
  }

  onCategoryChange = (category) => {
    const {item} = this.props;
    item.category = category;
    this.props.onChange(this.props.name, item);
  }

  onCategoryCodeChange = (event) => {
    const {item} = this.props;
    item.categoryCode = event.target.value;
    this.props.onChange(this.props.name, item);
  }

  onCheckboxChange = (event) => {
    const {item} = this.props;
    item.active = event.target.checked;
    this.props.onChange(this.props.name, item);
  }

  onInputNumberChange = (property, number) => {
    const {item} = this.props;
    item[property] = number;
    this.props.onChange(this.props.name, item);
  }

  onLanguageChoiceValidation = (values) => {
    const {item} = this.props;
    item.description = values;
    this.props.onChange(this.props.name, item);
  }

  onRemoveMLItem = (event) => {
    event.stopPropagation();
    this.props.onRemoveMLItem()
  }

  onTimePickerChange = (time) => {
    const {item} = this.props;
    item.duration = time ? `PT${time.hour()}H${time.minute()}M` : undefined;
    this.props.onChange(this.props.name, item);
  }

  renderLanguageChoice = () => {
    const {intl: {formatMessage}, intl, item} = this.props;
    if (!item.description) {
      return null;
    }
    return <p>{formatMessage({id: `${intl.locale}`})} : {item.description[intl.locale]}</p>
  };

  render() {
    const {config, intl: {formatMessage}, error = {}, item, name} = this.props;
    const checked = item.active || item.default;
    const disabled = this.props.disabled || item.default;

    return (
      <div className={"checkbox-item"}>
        <div className={"row"}>
          <div className={"col-xs-12 col-xl-6"}>
            {this.props.canWrite
              ?
              <span>
                <Checkbox name={`${name}.active`} onChange={this.onCheckboxChange} disabled={disabled} checked={checked}>
                  {formatMessage({id: this.props.labelKey})}
                </Checkbox>
                {this.props.canEditMLItem &&
                  <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={item.id} onValidate={this.props.onSaveMLItem} values={item.mlItem}>
                      <span>
                        &nbsp;
                        <a className={"smaller"}>{formatMessage({id: 'action.edit'})}</a>
                        &nbsp;
                        <a className={"smaller"} onClick={(event) => this.onRemoveMLItem(event)}>{formatMessage({id: 'action.delete'})}</a>
                      </span>
                  </LabelEncoder>
                }
              </span>
              :
              <span>
                <Checkbox disabled={true} checked={checked}>{formatMessage({id: this.props.labelKey})}</Checkbox>
              </span>
            }
          </div>
          <div className={"col-xs-12 col-xl-6"}>
            {config.categoryCode &&
              <span>
                <SAInput name={`${name}.categoryCode`} placeholder={formatMessage({id: 'placeholder.service-category-code'})} className={"input"} maxLength={5}
                         value={item.categoryCode} disabled={!this.props.canWrite || !checked || item.category !== Constants.MAINTENANCE_AND_REPAIR_SERVICE.value}
                         onChange={this.onCategoryCodeChange}
                         error={error[`${name}.categoryCode`]}
                />
              </span>
            }
            {config.category &&
              <span>
                <ServiceCategorySelector name={`${name}.category`} className={"input"} service={item.id || item.name}
                                         value={item.category} disabled={!this.props.canWrite || !checked}
                                         onChange={this.onCategoryChange}
                                         error={error[`${name}.category`]}
                />
              </span>
            }
            {config.timePicker &&
              <span>
                <SATimePicker name={`${name}.duration`} placeholder={formatMessage({id: 'placeholder.duration'})} className={"input"}
                              value={item.duration ? item.duration : ''} disabled={!this.props.canWrite || !checked}
                              onChange={this.onTimePickerChange}
                              error={error[`${name}.duration`]}
                />
              </span>
            }
            {config.price &&
              <span>
                <SAInputCurrency name={`${name}.price`} placeholder={formatMessage({id: 'placeholder.price'})} className={"input " + (error[`${name}.price`] ? "error" : "")}
                                 value={item.price ? item.price : undefined} disabled={!this.props.canWrite || !checked}
                                 onChange={(number) => this.onInputNumberChange('price', number)}
                                 error={error[`${name}.price`]}
                />
              </span>
            }

            {config.range &&
              <span>
                {this.props.canWrite
                  ?
                  <span>
                    <SAInputDistance name={`${name}.rangeOfKilometers`} placeholder={formatMessage({id: 'placeholder.rangeOfKilometers'})} className={"input " + (error[`${name}.price`] ? "error" : "")}
                                     value={item.rangeOfKilometers ? item.rangeOfKilometers : undefined} disabled={!checked}
                                     onChange={(number) => this.onInputNumberChange('rangeOfKilometers', number)}
                                     error={error[`${name}.rangeOfKilometers`]}
                    />
                  </span>
                  :
                  <span className="right picker-right">
                    {item.rangeOfKilometers ? `${item.rangeOfKilometers} Km` : ''}
                  </span>
                }
              </span>
            }
          </div>
        </div>
        {config.languageChoice && checked &&
          <ul className="list">
            <span>
              <div><br/>{this.renderLanguageChoice()}</div>
              {this.props.canWrite &&
                <span>
                  <li className={"list__footer" + (error[`${name}.description`] && error[`${name}.description`].message ? " error" : "")}>
                    <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} onValidate={this.onLanguageChoiceValidation} mandatory={this.props.mandatoryDescription} values={item.description}>
                        <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                          <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                            <use xlinkHref="#icon-plus"/>
                          </svg>
                          <strong>{formatMessage({id: 'section.mobility.setDescription'})}</strong>
                        </Button>
                    </LabelEncoder>
                  </li>
                  {error[`${name}.description`] && error[`${name}.description`].message &&
                    <div className={"txt-error"}>
                      {formatMessage({id: error[`${name}.description`].message})}
                    </div>
                  }
                </span>
              }
            </span>
          </ul>
        }
      </div>

    );
  }

}

export default injectIntl(CheckboxItem);
